export const USER_MANAGEMENT_IMPORT_DATA_SUCCESS =
  'USER_MANAGEMENT_IMPORT_DATA_SUCCESS';
export const USER_MANAGEMENT_IMPORT_DATA_FAILURE =
  'USER_MANAGEMENT_IMPORT_DATA_FAILURE';
